<template>
  <div class="cropper-content"  v-loading="trueImg == true">
    <div class="cropper-box">
      <div class="cropper">
        <vue-cropper
            ref="cropper"
            :img="option.img"
            :outputSize="option.outputSize"
            :outputType="option.outputType"
            :info="option.info"
            :canScale="option.canScale"
            :autoCrop="option.autoCrop"
            :autoCropWidth="option.autoCropWidth"
            :autoCropHeight="option.autoCropHeight"
            :fixed="option.fixed"
            :fixedNumber="option.fixedNumber"
            :full="option.full"
            :fixedBox="option.fixedBox"
            :canMove="option.canMove"
            :canMoveBox="option.canMoveBox"
            :original="option.original"
            :centerBox="option.centerBox"
            :height="option.height"
            :infoTrue="option.infoTrue"
            :maxImgSize="option.maxImgSize"
            :enlarge="option.enlarge"
            :mode="option.mode"
            @realTime="realTime"
            @imgLoad="imgLoad">
        </vue-cropper>
      </div>
      <!--底部操作工具按钮-->
      <div class="footer-btn">
        <div class="scope-btn">
          <label class="btn " for="uploads">选择图片</label>
          <input type="file" id="uploads" style="position:absolute; clip:rect(0 0 0 0);" accept="image/png, image/jpeg, image/gif, image/jpg" @change="selectImg($event)">
          <el-button size="mini" type="danger" plain icon="el-icon-zoom-in" @click="changeScale(1)">放大</el-button>
          <el-button size="mini" type="danger" plain icon="el-icon-zoom-out" @click="changeScale(-1)">缩小</el-button>
          <el-button size="mini" type="danger" plain @click="rotateLeft">↺ 左旋转</el-button>
          <el-button size="mini" type="danger" plain @click="rotateRight">↻ 右旋转</el-button>
        </div>
        <div class="upload-btn">
          <el-button size="mini" type="success" @click="uploadImg('blob')"> 上传图片 <i class="el-icon-upload"></i></el-button>
        </div>
      </div>
    </div>
    <!--预览效果图-->
    <div class="show-preview">
      <div :style="previews.div" class="preview">
        <img :src="previews.url" :style="previews.img">
      </div>
    </div>
  </div>
</template>

<script>

import { VueCropper } from 'vue-cropper'
import { baseUrl } from "../config/env.js";
 import { compressImage }from "../api/compressImage"
export default {
  name: "CropperImage",
  components: {
    VueCropper
  },
  props:['Name'],
  data() {
    return {
      name:this.Name,
      compressImage,
      previews: {},
      trueImg:false,
      option:{
        img: '',             //裁剪图片的地址
        outputSize: 1,       //裁剪生成图片的质量(可选0.1 - 1)
        outputType: 'png',  //裁剪生成图片的格式（jpeg || png || webp）
        info: true,          //图片大小信息
        canScale: true,      //图片是否允许滚轮缩放
        autoCrop: true,      //是否默认生成截图框
        autoCropWidth: '' , //默认生成截图框宽度
        autoCropHeight: '', //默认生成截图框高度
        fixed: true,         //是否开启截图框宽高固定比例
        fixedNumber: [1, 1], //截图框的宽高比例
        full: true,         //false按原比例裁切图片，不失真
        fixedBox: true,      //固定截图框大小，不允许改变
        canMove: false,      //上传图片是否可以移动
        canMoveBox: true,    //截图框能否拖动
        original: false,     //上传图片按照原始比例渲染
        centerBox: false,    //截图框是否被限制在图片里面
        height: true,        //是否按照设备的dpr 输出等比例图片
        infoTrue: false,     //true为展示真实输出图片宽高，false展示看到的截图框宽高
        maxImgSize: 3000,    //限制图片最大宽度和高度
        enlarge: 1,          //图片根据截图框输出比例倍数
        mode: '345px 225px'  //图片默认渲染方式
      }
    };
  },
 
  created(){
      if(this.name == 'HeadUrl' || this.name == 'KFQrCode'){
         this.option.autoCropWidth = 200
         
        this.option.autoCropHeight=  200
           this.option.fixedNumber =[1, 1]
      } 
      if(this.name == 'img1' || this.name == 'img2' || this.name == 'img3'){
         this.option.autoCropWidth = 242
         this.option.autoCropHeight= 162
         this.option.fixedNumber =[242, 162]
      }
      if(this.name == 'ImgOpusUrl'){
         this.option.autoCropWidth = 242
         this.option.autoCropHeight= 162
         this.option.fixedNumber =[242, 162]
      }
  },

  methods: {
    //初始化函数
    imgLoad (msg) {
      
        this.trueImg = false 
      if(this.name == 'KFQrCode' || this.name == 'HeadUrl'){

          this.option.autoCropWidth = 200
          this.option.autoCropHeight=  200
          this.option.fixedNumber =[1, 1]

      } 
      if(this.name == 'img1' || this.name == 'img2' || this.name == 'img3' || this.name == 'HeadUrllogo' ){
           this.option.autoCropWidth = 242
         this.option.autoCropHeight= 162
         this.option.fixedNumber =[242, 162]
      }

      // console.log("工具初始化函数====="+msg)
    },
    //图片缩放
    changeScale (num) {
      num = num || 1
      this.$refs.cropper.changeScale(num)
    },
    //向左旋转
    rotateLeft () {
      this.$refs.cropper.rotateLeft()
    },
    //向右旋转
    rotateRight () {
      this.$refs.cropper.rotateRight()
    },
    //实时预览函数
    realTime (data) {
      this.previews = data
    },
    //选择图片
    selectImg (e) {
      this.trueImg = true 
      let file = e.target.files[0]
      if (!/\.(jpg|jpeg|png|JPG|PNG)$/.test(e.target.value)) {
        this.$message({
          message: '图片类型要求：jpeg、jpg、png',
          type: "error"
        });
        return false
      }
      //转化为blob
      let reader = new FileReader()
      reader.onload = (e) => {
        let data
        if (typeof e.target.result === 'object') {
          data = window.URL.createObjectURL(new Blob([e.target.result]))
        } else {
          data = e.target.result
        }
        this.option.img = data
      }
      //转化为base64
      reader.readAsDataURL(file)
    },base64ImgtoFile(dataurl, filename = 'file') {
  let arr = dataurl.split(',')
  let mime = arr[0].match(/:(.*?);/)[1]
  let suffix = mime.split('/')[1]
  let bstr = atob(arr[1])
  let n = bstr.length
  let u8arr = new Uint8Array(n)
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n)
  }
  return new File([u8arr], `${filename}.${suffix}`, {
    type: mime
  })
},
    //上传图片
    uploadImg (type) {
      let _this = this;
      if (type === 'blob') {
        //获取截图的blob数据
        this.$refs.cropper.getCropBlob(async (data) => {
          console.log('Blob==' +data);

             var file = data; 
             let fileSize = parseFloat(file.size / 1024 / 1024).toFixed(2)
              console.log('fileSize==' +fileSize);

             if(fileSize>1){
              let config = {
　                  　width: this.option.autoCropWidth * 3, // 压缩后图片的宽
　　                    height: this.option.autoCropHeight *3, // 压缩后图片的高
　　                quality: 1 // 压缩后图片的清晰度，取值0-1，值越小，所绘制出的图像越模糊
                }
              compressImage(file, config)
　              　.then(async result => { // result 为压缩后二进制文件

              console.log('result==' +parseFloat(result.size / 1024 / 1024).toFixed(2));

 　             let formData = new FormData();
           var URL = baseUrl + "upload_images.aspx";
          formData.append('file',result,"DX.jpg")
          formData.append("token",localStorage.getItem("token"));
          //调用axios上传
          let {data: res} = await _this.$axios.post( URL, formData)
          if(res.orsuccess == 1){
            _this.$message({
              message: res.Msg,
              type: "success"
            });
            // let data = res.data.replace('[','').replace(']','').split(',');
            let imgInfo = {
              name :'',
              url : res.url
            };
            _this.$emit('uploadImgSuccess',imgInfo);

          }else {
            _this.$message({
              message: '文件服务异常，请联系管理员！',
              type: "error"
            });
          }
                  
　              　})
            }else{
          let formData = new FormData();
           var URL = baseUrl + "upload_images.aspx";
          formData.append('file',data,"DX.jpg")
          formData.append("token",localStorage.getItem("token"));
          //调用axios上传
          let {data: res} = await _this.$axios.post( URL, formData)
          if(res.orsuccess == 1){
            _this.$message({
              message: res.Msg,
              type: "success"
            });
            // let data = res.data.replace('[','').replace(']','').split(',');
            let imgInfo = {
              name :'',
              url : res.url
            };
            _this.$emit('uploadImgSuccess',imgInfo);

          }else {
            _this.$message({
              message: '文件服务异常，请联系管理员！',
              type: "error"
            });
          }

            }
          
        })
      }
    },
  },
}
</script>

<style scoped>
.upload-btn{
      border: none !important
}
.cropper-content{
  display: flex;
  display: -webkit-flex;
  justify-content: flex-end;

}
  .cropper-box{
    flex: 1;
    width: 100%;
    
  }
.cropper{
      width: auto;
      height: 300px;
    }
  .show-preview{
    flex: 1;
    -webkit-flex: 1;
    display: flex;
    display: -webkit-flex;
    justify-content: center;
   
  }
   .preview{
      overflow: hidden;
      border:1px solid #67c23a;
      background: #cccccc;
    }
.footer-btn{
  margin-top: 30px;
  display: flex;
  display: -webkit-flex;
  justify-content: flex-end;
  
}
.scope-btn{
    display: flex;
    display: -webkit-flex;
    justify-content: space-between;
    padding-right: 10px;
  }
  .upload-btn{
    flex: 1;
    -webkit-flex: 1;
    display: flex;
    display: -webkit-flex;
    justify-content: center;
  }
  .btn {
    outline: none;
    display: inline-block;
    line-height: 1;
    white-space: nowrap;
    cursor: pointer;
    -webkit-appearance: none;
    text-align: center;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    outline: 0;
    -webkit-transition: .1s;
    transition: .1s;
    font-weight: 500;
    padding: 13px 15px;
    font-size: 12px;
    border-radius: 3px;
    color: #fff;
    background-color: #409EFF;
    border-color: #409EFF;
    margin-right: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/CropperImage.vue